/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

export * from './card';
export * from './module';



// WEBPACK FOOTER //
// ../../../../../src/material/card/public-api.ts